// src/components/LandingPage.js
import React from 'react';
import { Container, Header, Button, Grid, Image, Segment } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import HowItWorks from './HowItWorks';

export default function LandingPage() {
  return (
    <div>
      <Segment
        inverted
        textAlign='center'
        style={{ minHeight: 700, padding: '1em 0em' }}
        vertical
      >
        <Container>
          <Header
            as='h1'
            content='Animate Your Icons with AI'
            inverted
            centered
            style={{ fontSize: '4em', fontWeight: 'normal', marginBottom: 0, marginTop: '3em' }}
          />
          <Header
            as='h2'
            content='Easily upload your icons and let our AI bring them to life.'
            inverted
            centered
            style={{ fontSize: '1.7em', fontWeight: 'normal' }}
          />
          <Grid centered>
            <Grid.Row>
              <Button size='huge' primary as={Link} to='/signup'>
                Get Started
              </Button>
              <Button size='huge' as={Link} to='/learn-more'>
                Learn More
              </Button>
            </Grid.Row>
          </Grid>
        </Container>
        <Container style={{ marginTop: 40, marginBottom: 40 }}>
          <Grid centered>
            <Grid.Row>
              <Image src='/logoAnimateYouIcon_white.svg' size='small' centered />
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>

      <Segment vertical>
        <HowItWorks />
      </Segment>

      <Segment inverted vertical style={{ padding: '5em 0em' }}>
        <Container textAlign='center'>
          <Header as='h4' inverted>
            © {new Date().getFullYear()} Animate Your Icons. All rights reserved.
          </Header>
        </Container>
      </Segment>
    </div>
  );
}
